import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-service-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                女仆教育
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              专业女仆培训教育机构，致力于培养优秀的女仆服务人才，推动行业标准化与专业化发展。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">课程分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/liyi-guifan" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">礼仪规范</Link></li>
              <li><Link to="/category/fuwu-jineng" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">服务技能</Link></li>
              <li><Link to="/category/zhiye-fazhan" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">职业发展</Link></li>
              <li><Link to="/category/hangye-zhishi" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">行业知识</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">联系方式</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line text-primary-400"></i>
                上海市徐汇区衡山路888号
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line text-primary-400"></i>
                400-888-9999
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line text-primary-400"></i>
                info@hkxwhcm.cn
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 女仆教育 版权所有 | 沪ICP备2024000000号
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}